import localStorageService from 'services/LocalStorageService';

/**
 * @class ControlledFeatureService used for checking if a user belongs to a group that has a specific feature enabled
 */
class ControlledFeatureService {
  /**
   * Property used to store current user's controlledFeatures List
   * @memberof ControlledFeatureService
   */
  userControlledFeatures;

  /**
   * Property used to store profile's controlledFeatures List
   * @memberof ControlledFeatureService
   */
  profileControlledFeatures = [];

  /**
   * Sets property userControlledFeatures to user's controlledFeatures property or empty array
   * @param {object} user
   * @returns instance of ControlledFeatureService
   */
  setUser(user) {
    if (user && user.user && typeof user.user.get === 'function') {
      this.userControlledFeatures = user?.user?.get?.('user')?.get?.('controlledFeatures') || [];
    } else {
      this.userControlledFeatures = user && user.controlledFeatures ? user.controlledFeatures : [];
    }

    return this;
  }

  setProfileControlledFeatures(data) {
    if (Array.isArray(data)) {
      this.profileControlledFeatures = data;
    }
  }

  /**
   * Checks whether feature passed in is present in the userControlledFeatures list
   * @param {string} feature
   * @returns boolean result of check
   */
  has(feature) {
    let localStorageCF = undefined;

    try {
      localStorageCF = JSON.parse(localStorageService.get(`FC_${feature}`)) || undefined;
    } catch (err) {
      // Ignore and move forward
    }

    if (localStorageCF !== undefined) {
      return localStorageCF;
    }

    const hasUserControlledFeature = this.userControlledFeatures?.includes?.(feature);
    const hasForcedControlledFeature = window.forceUserControlledFeatures?.includes?.(feature);
    const hasProfileControlledFeature = this.profileControlledFeatures?.includes?.(feature);

    return hasUserControlledFeature || hasForcedControlledFeature || hasProfileControlledFeature;
  }
}

export default new ControlledFeatureService();
